import React from "react";
import ReactAutocomplete from 'react-autocomplete';
import { connect } from "react-redux";
import 'react-day-picker/lib/style.css';

class FilterPane extends React.Component {

    handleFilter(e) {
        e.preventDefault();

        this.props.handleSubmit();
        this.setState({ isOpen: false })
    }

    render() {
        const {
            isOpen,
            filters,
            resetFilters,
            handleInput,
            orderMethodType,
            handleObject,
            handleObjectSelect,
            autocompleteData,
        } = this.props;
        const {
            q,
            order_id,
            object_id,
            object_value,
            orderposition__order_method_type_id,
            order_by,
        } = filters;

        const { isFetching } = this.props.orderList;

        return (
            <div className={`filter-container ${isOpen ? 'active' : ''}`}>
                <div className="filter-container-inner">
                    <input
                        type="number"
                        min="1"
                        name="order_id"
                        value={order_id}
                        className="form-input-el"
                        style={{marginBottom: '25px'}}
                        placeholder="поиск по номеру заказа"
                        onChange={(e) => handleInput(e.target)}
                        />


                    <ReactAutocomplete
                        inputProps={{placeholder: "поиск по объекту"}}
                        items={[
                            ...autocompleteData.results
                        ]}
                        renderInput={(props) => <input {...props} className="form-input-el" style={{width:'100%'}}/>}
                        shouldItemRender={(item, value) => item.title.toLowerCase().indexOf(value.toLowerCase()) > -1}
                        getItemValue={item => item.title}
                        wrapperStyle={{ position:'relative'}}
                        renderItem={(item, highlighted) => 
                            <div
                                key={item.id}
                                style={{ backgroundColor: highlighted ? '#eee' : 'transparent'}}>
                                {item.title}
                            </div>
                        }
                        renderMenu={(items, value) =>{
                            return <div className="autocomplete-dropdown" children={items}/>
                        }}
                        value={object_value}
                        onChange={(e) => handleObject(e.target.value)}
                        onSelect={(value, item) => handleObjectSelect(item)}
                    />


                    <select
                        value={orderposition__order_method_type_id}
                        name="orderposition__order_method_type_id"
                        onChange={(e) => handleInput(e.target)}
                        className="form-select"
                        style={{width:'48%', height:'40px', marginBottom: '25px'}}
                        >
                        <option value="0">Выберите метод</option>
                        {
                            orderMethodType.results.map((item, index) => {
                                return <option key={index} value={item.id}>{item.title}</option>
                            })
                        }
                    </select>

                    <select
                        value={order_by}
                        name="order_by"
                        className="form-select"
                        style={{width:'48%', height:'40px', marginBottom: '25px'}}
                        onChange={(e) => handleInput(e.target)}
                        >
                        <option value="-cached_likes_count">по лайкам</option>
                        <option value="-created_at">по дате создания</option>
                        <option value="price">по цене (от меньшего к большему)</option>
                        <option value="-price">по цене (от большего к меньшему)</option>
                    </select>

                    <a href=""
                        onClick={(e) => resetFilters(e)}
                        style={{lineHeight:'50px'}}
                        className="main-filter-form-reset"
                        >Сбросить фильтр</a>

                    <div className="big-button button-action" style={{width:'48%', minWidth: '120px'}}>
                        <button
                            type="submit"
                            onClick={(e) => this.handleFilter(e)}
                            className={isFetching ? 'disabled' : ''}>
                            Применить
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        ...state
    };
};

export default connect(mapStateToProps)(FilterPane);



// WEBPACK FOOTER //
// ./src/components/BuyReady/FilterPane.js